module.exports = __webpack_public_path__ + "img/submenu-mob-open.3ce801e7.svg";